import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "@/components/Navbar";
import { SupportHero } from "@/components/support/SupportHero";
import { SupportTabs } from "@/components/support/SupportTabs";
import { SponsorImpact } from "@/components/sponsor/SponsorImpact";
import { SponsorFAQ } from "@/components/sponsor/SponsorFAQ";
import Footer from "@/components/Footer";
import { useScrollToTop } from "@/hooks/useScrollToTop";

const Support = () => {
  useScrollToTop();

  return (
    <>
      <Helmet>
        <title>Support Bobo & Teedee® | Corporate Partnerships & Individual Donations</title>
        <meta 
          name="description" 
          content="Support Bobo & Teedee® through corporate partnerships or individual donations. Help us bring quality children's entertainment and Cayman Islands culture to families worldwide." 
        />
        <meta name="keywords" content="support, donate, corporate sponsorship, individual donations, children's education, Cayman Islands culture, partnership" />
        <link rel="canonical" href="https://boboandteedee.com/support" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Support Bobo & Teedee® | Corporate Partnerships & Individual Donations" />
        <meta property="og:description" content="Support us through corporate partnerships or individual donations to bring quality children's content worldwide." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://boboandteedee.com/support" />
        <meta property="og:image" content="https://boboandteedee.com/img/social/og-default.png" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Support Bobo & Teedee®" />
        <meta name="twitter:description" content="Support us through corporate partnerships or individual donations." />
        <meta name="twitter:image" content="https://boboandteedee.com/img/social/twitter-default.png" />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Support - Bobo & Teedee®",
            "description": "Support Bobo & Teedee® through corporate partnerships or individual donations to bring quality children's entertainment and Cayman Islands culture to families worldwide.",
            "url": "https://boboandteedee.com/support",
            "mainEntity": {
              "@type": "Organization",
              "name": "Bobo & Teedee®",
              "description": "Educational entertainment featuring Cayman Islands culture for children",
              "url": "https://boboandteedee.com"
            }
          })}
        </script>
      </Helmet>

      <Navbar />
      <main className="min-h-screen">
        <SupportHero />
        <SponsorImpact />
        <SupportTabs />
        <SponsorFAQ />
      </main>
      <Footer />
    </>
  );
};

export default Support;